module.exports = __webpack_public_path__ + "static/media/2_PoAs-116-ZPPCK_Formoplast_20160622.ce7aa7e7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/2_PoAs-116-ZPPCK_Formoplast_20160622.pdf
// module id = 163
// module chunks = 0